import { ContentTypeFilterClause, MixedContentItemDefinition, SpaceDefinition } from './ContentDefinitionsTypes';
import { Messages } from '../../../codegen/Localize';
import { DataRoleContentType } from '../ContentTypes';
import { getGenericDefaultFilters } from './getDefaultFilters';
import { DataRoleCard } from '../../../app/spaces/CardView/DataRoleCard';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { ServerFilterClauses } from '../../helpers/ServerFilterClauses';
import { SpacesSiteUrls } from '../../../app/spaces/SpacesSiteUrls';
import { DataRoles } from '../../resources/Dataroles';
import { IContentInfo } from '../IContentInfo';
import { call } from 'redux-saga/effects';
import { getDataRoleInfos } from '../../../app/sagas/spaces/SpacesSagaHelpers';

export const DataRoleDefinition: MixedContentItemDefinition & SpaceDefinition<'dataRole'> = {
  itemType: 'dataRole',
  contentType: 'dataRole',
  singularName: Messages.dataRole,
  pluralName: Messages.dataRoles,
  emptyStateMessage: Messages.dataRolesEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_Dataroles,
  contentFilterKeys: DataRoleContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: DataRoleCard,
  listViewIconUrl: imgPath('datasource_role_18px-large.svg'),
  filterClause: ServerFilterClauses.ContentType(['dataRole']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.dataRoleUrl(contentId),
  getBasicQuery: () => {
    return DataRoles.all().withExtraParams(DataRoleContentType.extraQueryParams);
  },
  fieldValueResourceType: 'dataRole',
  getContentInfo: (contentList: IContentInfo[]) => call(getDataRoleInfos, contentList),
  supportedDisplayModes: ['list', 'thumbnail'],
  headerIconPath: () => imgPath('spaces_masthead_datarole.svg'),
};
